import React from 'react';

const StampIcon = (props) => (
  <svg
    data-type="fill"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
    {...props}
  >
    <path
      d="M 5 2 L 5 3 L 4 3 L 4 6 L 5 6 L 5 8 L 4 8 L 4 11 L 5 11 L 5 13 L 4 13 L 4 16 L 5 16 L 5 18 L 4 18 L 4 21 L 5 21 L 5 22 L 8 22 L 8 21 L 10 21 L 10 22 L 14 22 L 14 21 L 16 21 L 16 22 L 19 22 L 19 21 L 20 21 L 20 18 L 19 18 L 19 16 L 20 16 L 20 13 L 19 13 L 19 11 L 20 11 L 20 8 L 19 8 L 19 6 L 20 6 L 20 3 L 19 3 L 19 2 L 16 2 L 16 3 L 14 3 L 14 2 L 10 2 L 10 3 L 8 3 L 8 2 L 5 2 z M 7 5 L 12 5 L 17 5 L 17 9 L 17 10 L 17 14 L 17 15 L 17 19 L 12 19 L 7 19 L 7 15 L 7 14 L 7 10 L 7 9 L 7 5 z"
    />
  </svg>
);

export default StampIcon;
